module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-c944491fcbfc371734d037f6f914c6c4.png";